import React from 'react'
import { FAIcon } from './FAIcon'
import { FormBox } from './FormBox'
import { TagsBox } from './TagsBox'
import styles from './DataGridSearch.less'
import { pt } from 'common-data/proptypehelpers'

export class DataGridSearch extends React.Component {
  static propTypes = {
    formName: pt.string.isRequired,
    onSubmit: pt.func.isRequired,
    fieldName: pt.string.isRequired,
    icon: pt.string.isRequired,
    loading: pt.bool.isRequired,
    promptText: pt.string,
    classNames: pt.shape({
      search: pt.string,
      searchForm: pt.string,
      searchIcon: pt.string
    }),
    hide: pt.bool.isRequired
  }

  static defaultProps = {
    classNames: {},
    hide: false,
    icon: 'search',
    loading: false
  }

  render () {
    const { 'data-tid': testId = '', formName, onSubmit, fieldName, classNames, hide, icon, loading, promptText } = this.props

    if (hide === true) {
      return null
    }

    return (
      <div className={classNames.search || styles.search}>
        <div className={classNames.searchIcon || styles.searchIcon}>
          <FAIcon name={icon || 'search'} />
        </div>
        <FormBox destroyOnUnmount={false} simpleBody className={classNames.searchForm || styles.searchForm} form={formName} loading={loading} onSubmit={onSubmit}>
          <TagsBox data-tid={testId} name={fieldName} noLayout placeHolder={promptText} />
        </FormBox>
      </div>
    )
  }
}
